import { Button } from "@mui/material";
import ManageDateFilter from "components/manageDateFilter";
import { MTableToolbar } from "material-table";
import React from "react";
import { Spinner } from "reactstrap";

export default function TableToolbar(props) {
  return (
    <>
    <div className="d-flex justify-content-between">
      {props.onClickImport ? <Button
        variant="outlined"
        style={{ height: "38px", width: "160px", margin: 20 }}
        onClick={props.onClickImport}
      >
        {props.loading ? <Spinner size="sm" /> : props.t("Import Data")}
      </Button> : <div/>}
      <div className="d-none d-md-flex flex-1 align-items-center">
        <ManageDateFilter className="justify-content-end" />
        <div className="mt-4" style={{marginLeft: -40}}>
          <MTableToolbar {...props} />
        </div>
      </div>
      <div className="d-flex d-md-none">
        <MTableToolbar {...props} />
      </div>
    </div>
    <div className="d-flex d-md-none">
    <ManageDateFilter className="justify-content-end" />
    </div>
    </>
  );
}
